import {
  Auslandsrisikoort,
  BasisAdresse,
  convertSafeDomaenenwert,
} from '@ps20-frontend/frontend-models';
import { AdresseAntrag } from '@ps20/bff-models';

export function convertBasisAdresseToBffAdresse(basisAdresse: BasisAdresse): AdresseAntrag {
  if (!basisAdresse) {
    return null;
  }
  return {
    plz: basisAdresse.plz,
    ort: basisAdresse.ort,
    strasse: basisAdresse.strasse,
    hausnummer: basisAdresse.hausnummer,
    longtitude: basisAdresse.longtitude,
    latitude: basisAdresse.latitude,
  };
}

export function convertRisikoortToBffAdresse(risikoort: Auslandsrisikoort): AdresseAntrag {
  if (!risikoort) {
    return null;
  }
  return {
    plz: risikoort.plz,
    ort: risikoort.ort,
    strasse: risikoort.strasse,
    hausnummer: risikoort.hausnummer,
    land: convertSafeDomaenenwert(risikoort.land),
    ortsteil: risikoort.ortsteil,
    hausnrzus: risikoort.hausnrzus,
    latitude: risikoort.latitude,
    longtitude: risikoort.longtitude,
    auslandsadresse: risikoort.auslandsadresse,
    auslandsrisiko: risikoort.auslandsrisiko,
  };
}

export function equalAdressen(a1: BasisAdresse, a2: BasisAdresse): boolean {
  return (
    a1 != null &&
    a2 != null &&
    a1.plz === a2.plz &&
    a1.ort === a2.ort &&
    a1.strasse === a2.strasse &&
    trimAndLowerCase(a1.hausnummer) === trimAndLowerCase(a2.hausnummer)
  );
}

function trimAndLowerCase(text: string): string {
  return text ? text.trim().toLowerCase() : '';
}
